/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Col_PeriodInputs */

const vi_warehouse_defects_col_period = /** @type {(inputs: Warehouse_Defects_Col_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kỳ`)
};

/**

* @param {Warehouse_Defects_Col_PeriodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_col_period = /** @type {((inputs?: Warehouse_Defects_Col_PeriodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Col_PeriodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_col_period(inputs)
});